module.exports = __webpack_public_path__ + "img/prioritas_bosspack_cod_k.b3c0e8fb.png";